// Copyright Epic Games, Inc. All Rights Reserved.

import {
  applyMiddleware,
  CombinedState,
  combineReducers,
  createStore,
  Store,
} from "redux";
import createSagaMiddleware, { Task } from "@redux-saga/core";
import { rootSaga } from "./sagas";
import {
  installationFeatureStoreKey,
  installationReducer,
} from "./installation/reducer";
import {
  localizationFeatureStoreKey,
  localizationReducer,
} from "./localization/reducer";
import { sharedReducer, sharedFeatureStoreKey } from "./shared/reducer";

const rootReducer = combineReducers({
  [installationFeatureStoreKey]: installationReducer,
  [sharedFeatureStoreKey]: sharedReducer,
  [localizationFeatureStoreKey]: localizationReducer,
});
export type IAppState = { sagaTask?: Task } & ReturnType<typeof rootReducer>;

const sagaMiddleware = createSagaMiddleware();

const store: Store<CombinedState<ReturnType<typeof rootReducer>>> = createStore(
  rootReducer,
  applyMiddleware(sagaMiddleware)
);
((store as unknown) as IAppState).sagaTask = sagaMiddleware.run(rootSaga);

export default store;
